import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step902407Meta extends BaseModel {
  /**
   * @var {boolean}
   */
  isWitnessBeneficiary;

  /**
   * @var {string}
   */
  relationToDeceased;

  constructor(model = {}) {
    super();
    this.isWitnessBeneficiary = model.isWitnessBeneficiary;
    this.relationToDeceased = model.relationToDeceased;
  }
}
